/**
 * Canonical school-wide chat message (mirror of app/src/utils/schoolChatMessage.ts)
 */

export function buildSchoolChatMessage(params) {
  const d = new Date();
  const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const time = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
  const sentTime = d.getTime();
  const id =
    params.id ||
    `${sentTime}-${params.senderMongoId}-${Math.random().toString(36).slice(2, 9)}`;

  return {
    id,
    schoolID: params.schoolID,
    message: params.messageText,
    senderid: params.senderMongoId,
    sender: params.senderDisplayName,
    image: params.image,
    reply: [],
    seen: [params.senderMongoId],
    date,
    time,
    sentTime,
    mediaUrl: params.mediaUrl,
    thread: 'school',
  };
}

export function normalizeSchoolChatPayload(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const schoolID = raw.schoolID != null ? String(raw.schoolID) : '';
  if (!schoolID) return null;

  const msg =
    raw.message != null
      ? String(raw.message)
      : raw.body != null
        ? String(raw.body)
        : '';
  const sender =
    raw.sender != null
      ? String(raw.sender)
      : raw.senderName != null
        ? String(raw.senderName)
        : 'Unknown';

  let senderid = raw.senderid != null ? String(raw.senderid) : '';
  if (!senderid && raw.senderId != null) senderid = String(raw.senderId);

  const sentRaw = raw.sentTime;
  let sentTime;
  if (typeof sentRaw === 'number' && !Number.isNaN(sentRaw)) {
    sentTime = sentRaw;
  } else if (typeof sentRaw === 'string') {
    const p = Date.parse(sentRaw);
    sentTime = Number.isNaN(p) ? Date.now() : p;
  } else {
    sentTime = Date.now();
  }

  const d = new Date(sentTime);
  const date =
    raw.date ||
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const time =
    raw.time ||
    `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;

  const id =
    raw.id != null
      ? String(raw.id)
      : `${sentTime}-${senderid || 'na'}`;

  const seen = Array.isArray(raw.seen)
    ? raw.seen.map((x) => String(x))
    : senderid
      ? [senderid]
      : [];

  return {
    id,
    schoolID,
    message: msg,
    senderid,
    sender,
    image: raw.image != null ? String(raw.image) : undefined,
    reply: Array.isArray(raw.reply) ? raw.reply : [],
    seen,
    date,
    time,
    sentTime,
    mediaUrl: raw.mediaUrl != null ? String(raw.mediaUrl) : undefined,
    thread: raw.thread === 'direct' || raw.thread === 'group' ? raw.thread : 'school',
    conversationId:
      raw.conversationId != null ? String(raw.conversationId) : undefined,
  };
}
